export default "__VITE_ASSET__B4I0$wQb__"